import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, OccConfig } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { ProductCategoryService } from 'src/app/services/feature/product-category.service';
import { RegisterService } from 'src/app/services/feature/register.service';

@Component({
  selector: 'app-kb-product-categories',
  templateUrl: './kb-product-categories.component.html',
  styleUrls: ['./kb-product-categories.component.scss'],
  standalone: false
})
export class KbProductCategoriesComponent {
  productCategoriesDetails: any;
  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';
  baseSite: string;
  subscription = new Subscription();



  constructor(
    private cmsService: CmsService,
    private baseSiteService: BaseSiteService,
    private productCategoryService: ProductCategoryService,
    private cdf: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private registerService: RegisterService,
    private globalMessageService: GlobalMessageService,
    private config: OccConfig
  ) {
    this.subscription.add(this.baseSiteService.getActive().subscribe((baseSite) => {
      this.baseSite = baseSite;
    }));
  }

  ngOnInit() {
    this.subscription.add(this.activatedRoute.queryParams.subscribe((param) => {
      const tokenValue = encodeURIComponent(param?.['id']);
      if (tokenValue && tokenValue !== 'undefined') {
        this.subscription.add(this.registerService.registerConfirmation(tokenValue).subscribe(
          (res: any) => {
            if (res?.message) {
              this.globalMessageService.add({ key: 'common.' + res?.message }, GlobalMessageType.MSG_TYPE_INFO);
            }
          },
          (error) => {
            this.globalMessageService.add(error?.error?.errors[0]?.message, GlobalMessageType.MSG_TYPE_ERROR);
          }
        ));
      }
    }));
    if (this.baseSite === 'EMEA') {
      this.subscription.add(this.productCategoryService.getProductCategoriesEMEA().subscribe((data: any) => {
        this.productCategoriesDetails = data.infoBoxWSList;
        this.cdf.detectChanges();
      }));
    } else {
      this.subscription.add(this.cmsService.getComponentData('KBHomepageProductCategoriesComponent').subscribe((data: any) => {
        this.productCategoriesDetails = data.categories;
      }));
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }
}
